import { NEW_MENU_TUTORIAL_SLIDES } from '../../components/new-menu-tutorial/newMenuTutorialSlides';

const loadedImages = new Set<string>();
const cachedImageSrcByUrl = new Map<string, string>();
const loadingPromises = new Map<string, Promise<void>>();

function collectImageUrls(): string[] {
  const urls = new Set<string>();

  NEW_MENU_TUTORIAL_SLIDES.forEach((slide) => {
    if (slide.type !== 'multiFrame') {
      return;
    }
    slide.frames.forEach((frame) => {
      if (frame.image) {
        urls.add(frame.image);
      }
    });
  });

  return Array.from(urls);
}

async function decodeImage(src: string): Promise<void> {
  const response = await fetch(src);
  const blob = await response.blob();
  const objectUrl = URL.createObjectURL(blob);
  const img = new Image();
  img.decoding = 'async';
  img.src = objectUrl;

  await new Promise<void>((resolve) => {
    img.onload = () => resolve();
    img.onerror = () => resolve();
  });

  try {
    await img.decode();
  } catch {
    /* already rendered or decode unsupported */
  }

  cachedImageSrcByUrl.set(src, objectUrl);
}

async function preloadImage(src: string): Promise<void> {
  if (loadedImages.has(src)) {
    return;
  }

  const existing = loadingPromises.get(src);
  if (existing) {
    return existing;
  }

  const promise = (async () => {
    try {
      await decodeImage(src);
    } catch {
      cachedImageSrcByUrl.set(src, src);
    } finally {
      loadedImages.add(src);
      loadingPromises.delete(src);
    }
  })();

  loadingPromises.set(src, promise);
  return promise;
}

export function isNewMenuTutorialImageCached(src: string): boolean {
  return loadedImages.has(src);
}

export function getNewMenuTutorialImageSrc(src: string): string {
  return cachedImageSrcByUrl.get(src) ?? src;
}

export function waitForNewMenuTutorialImage(src: string): Promise<void> {
  return preloadImage(src);
}

export function preloadNewMenuTutorialImages(): Promise<void> {
  return Promise.all(collectImageUrls().map(preloadImage)).then(() => undefined);
}
